/**
 * vendor-marked.js — self-hosted `marked` (MPE-557).
 *
 * Replaces <script src="https://cdn.jsdelivr.net/npm/marked@9.1.2/marked.min.js">.
 * The jsDelivr UMD build published the whole module namespace as
 * `window.marked`; callers in this app use BOTH shapes:
 *   - `marked.parse(md)`            (app.js, work-digest.js, story_detail…)
 *   - `marked(md)` as a function    (kept working for any legacy caller)
 * marked's own `marked` export is a callable that already carries `.parse`,
 * `.use`, `.setOptions`, `Renderer`, … as statics, so exposing it directly
 * satisfies both. Extra namespace members (Marked, Lexer, Parser, …) are
 * copied on for parity with the UMD global.
 *
 * Bundled by esbuild (BUNDLED_ENTRIES → IIFE) so nothing leaks to window
 * except the explicit assignment below.
 */
import * as markedNs from 'marked';

const marked = markedNs.marked;

for (const key of Object.keys(markedNs)) {
  if (key === 'marked' || key === 'default') continue;
  if (!(key in marked)) {
    try { marked[key] = markedNs[key]; } catch { /* frozen export — ignore */ }
  }
}

window.marked = marked;
